/**
 * DADD'E - SALE collection display.
 * Runs ONLY on /collections/sale, and only while DADDE_SALE.enabled is true.
 *
 * TWO MODES.
 *
 * 1. Live (default). The script never invents a price. A red '% OFF' tag is
 *    drawn on a card only if that card is rendering <s class="compare-at-price">,
 *    which the theme emits solely when compare_at_price > price. The banner
 *    appears only once at least one genuinely discounted product is on the page.
 *    So the page is self-correcting: before the real prices are written it looks
 *    like an ordinary collection, once they are live the banner and tags appear
 *    on their own, and when the prices are restored everything disappears again.
 *    A customer can never be shown a discount the checkout will not honour.
 *
 * 2. Preview. Add ?dadde_preview=1 to the URL and the page renders exactly how
 *    it will look once the real prices are live - banner, tags, struck-through
 *    originals and red sale prices, all calculated from the discount map. A
 *    dark 'PREVIEW' chip sits in the corner so simulated prices are never
 *    mistaken for real ones. No link on the site carries this parameter, so a
 *    customer can only reach it by typing it deliberately.
 *
 * It also renames the SORT options so the page reads as a curated edit:
 *   Featured (the manual, hand-picked order) -> Editor's Picks
 *   Date, new to old                          -> Newly Added
 *   Best selling                              -> Most Loved
 * That work is scoped inside <sorting-filter-component>, so the filter chips
 * (AVAILABILITY / PRICE / COLOR / SIZE) are never touched.
 *
 * The discount map and the enabled switch live in dadde-sale-map.js.
 */
(function () {
  var CFG = window.DADDE_SALE;
  if (!CFG || CFG.enabled === false) return;
  var DISCOUNTS = CFG.discounts;

  var PREVIEW = /[?&]dadde_preview=1/.test(window.location.search);

  var BANNER = {
    left: 'LIVE NOW:',
    right: 'SEASON SALE',
    word: 'UP TO 50% OFF',
    note: 'Selected pieces · Limited quantities · While stocks last'
  };

  var SORT_LABELS = {
    'manual': 'Editor\u2019s Picks',
    'created-descending': 'Newly Added',
    'best-selling': 'Most Loved'
  };

  function onSalePage() {
    return window.location.pathname.indexOf('/collections/sale') !== -1;
  }

  function handleFromHref(href) {
    var idx = href.indexOf('/products/');
    if (idx === -1) return null;
    return href.slice(idx + 10).split('?')[0].split('#')[0].split('/')[0];
  }

  /* The theme renders this element only when compare_at_price > price, so its
     presence is proof that Shopify itself is discounting the item. */
  function hasRealDiscount(scope) {
    return !!scope.querySelector('.compare-at-price');
  }

  function injectStyles() {
    if (document.getElementById('dadde-sale-styles')) return;
    var css = ''
      + '.dadde-sale-marquee{background:#0f0f0f;overflow:hidden;padding:14px 0 12px;margin:0 0 26px;}'
      + '.dadde-sale-marquee__meta{display:flex;justify-content:space-between;align-items:center;padding:0 20px 8px;font-size:10px;font-weight:600;letter-spacing:.18em;text-transform:uppercase;color:#ff2d20;}'
      + '.dadde-sale-marquee__track{display:flex;width:max-content;animation:dadde-marquee 26s linear infinite;}'
      + '.dadde-sale-marquee__group{display:flex;}'
      + '.dadde-sale-marquee__group span{font-size:clamp(20px,3.2vw,42px);font-weight:800;line-height:1.1;letter-spacing:-.01em;color:#ff2d20;white-space:nowrap;padding-inline-end:30px;}'
      + '.dadde-sale-marquee__note{padding:10px 20px 0;font-size:10px;letter-spacing:.08em;color:#ff2d20;opacity:.75;text-align:center;}'
      + '@keyframes dadde-marquee{from{transform:translateX(0);}to{transform:translateX(-50%);}}'
      + '@media (prefers-reduced-motion: reduce){.dadde-sale-marquee__track{animation:none;}}'
      + '@media (max-width:749px){'
      +   '.dadde-sale-marquee{padding:11px 0 9px;margin:0 0 18px;}'
      +   '.dadde-sale-marquee__meta{padding:0 14px 6px;font-size:9px;letter-spacing:.14em;}'
      +   '.dadde-sale-marquee__group span{font-size:20px;padding-inline-end:20px;}'
      +   '.dadde-sale-marquee__note{padding:8px 14px 0;font-size:9px;letter-spacing:.05em;}'
      + '}'
      + '.dadde-sale-badge{position:absolute;top:10px;left:10px;z-index:3;background:#e2231a;color:#fff;padding:5px 9px;font-size:10px;font-weight:700;letter-spacing:.05em;line-height:1;border-radius:2px;pointer-events:none;}'
      + '@media (max-width:749px){.dadde-sale-badge{top:7px;left:7px;padding:4px 7px;font-size:9px;}}'
      + '.dadde-compare-price{color:#9a9a9a;text-decoration:line-through;margin-inline-end:8px;}'
      + '.dadde-sale-price{color:#e2231a !important;}'
      + '.dadde-preview-flag{position:fixed;inset-inline-start:14px;inset-block-end:14px;z-index:9999;background:#111;color:#fff;padding:8px 12px;border-radius:3px;font-size:10px;font-weight:600;letter-spacing:.12em;text-transform:uppercase;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Arial,sans-serif;box-shadow:0 2px 10px rgba(0,0,0,.25);pointer-events:none;}'
      + '.dadde-preview-flag em{display:block;margin-block-start:3px;font-style:normal;font-weight:400;letter-spacing:.04em;text-transform:none;opacity:.7;}';
    var style = document.createElement('style');
    style.id = 'dadde-sale-styles';
    style.textContent = css;
    document.head.appendChild(style);
  }

  function addPreviewFlag() {
    if (!PREVIEW) return;
    if (document.getElementById('dadde-preview-flag')) return;
    if (!document.body) return;
    var flag = document.createElement('div');
    flag.id = 'dadde-preview-flag';
    flag.className = 'dadde-preview-flag';
    flag.textContent = 'Preview';
    var sub = document.createElement('em');
    sub.textContent = 'Simulated prices - not live';
    flag.appendChild(sub);
    document.body.appendChild(flag);
  }

  function setText(el, text) {
    if (el && el.textContent.trim() !== text) el.textContent = text;
  }

  function relabelSorting() {
    var roots = document.querySelectorAll('sorting-filter-component');
    for (var r = 0; r < roots.length; r++) {
      var root = roots[r];

      var options = root.querySelectorAll('.sorting-filter__option');
      for (var i = 0; i < options.length; i++) {
        var input = options[i].querySelector('input[name=sort_by]');
        if (!input) continue;
        var label = SORT_LABELS[input.value];
        if (!label) continue;
        if (input.getAttribute('data-option-name') !== label) {
          input.setAttribute('data-option-name', label);
        }
        setText(options[i].querySelector('.sorting-filter__label'), label);
      }

      var selectOptions = root.querySelectorAll('select[name=sort_by] option');
      for (var j = 0; j < selectOptions.length; j++) {
        var selLabel = SORT_LABELS[selectOptions[j].value];
        if (selLabel) setText(selectOptions[j], selLabel);
      }

      var checked = root.querySelector('input[name=sort_by]:checked');
      if (checked && SORT_LABELS[checked.value]) {
        var statuses = root.querySelectorAll('.facets__status');
        for (var k = 0; k < statuses.length; k++) {
          setText(statuses[k], SORT_LABELS[checked.value]);
        }
      }
    }
  }

  /* Only banner a page that actually has something on sale - or a preview. */
  function buildBanner() {
    if (document.querySelector('.dadde-sale-marquee')) return;
    if (!PREVIEW && !hasRealDiscount(document)) return;

    var anchor = document.querySelector('[id*=main-collection]');
    var main = document.getElementById('MainContent') || document.querySelector('main');
    if (!anchor && !main) return;

    var wrap = document.createElement('div');
    wrap.className = 'dadde-sale-marquee';

    var meta = document.createElement('div');
    meta.className = 'dadde-sale-marquee__meta';
    var left = document.createElement('span');
    left.textContent = BANNER.left;
    var right = document.createElement('span');
    right.textContent = BANNER.right;
    meta.appendChild(left);
    meta.appendChild(right);

    var track = document.createElement('div');
    track.className = 'dadde-sale-marquee__track';
    for (var g = 0; g < 2; g++) {
      var group = document.createElement('div');
      group.className = 'dadde-sale-marquee__group';
      for (var i = 0; i < 8; i++) {
        var word = document.createElement('span');
        word.textContent = BANNER.word;
        group.appendChild(word);
      }
      track.appendChild(group);
    }

    var note = document.createElement('div');
    note.className = 'dadde-sale-marquee__note';
    note.textContent = BANNER.note;

    wrap.appendChild(meta);
    wrap.appendChild(track);
    wrap.appendChild(note);

    if (anchor && anchor.parentNode) {
      anchor.parentNode.insertBefore(wrap, anchor);
    } else {
      main.insertBefore(wrap, main.firstChild);
    }
  }

  function cardFor(link) {
    return link.closest('product-card')
      || link.closest('.product-card')
      || link.closest('li')
      || link.parentElement;
  }

  function addBadge(card, discount) {
    if (card.querySelector('.dadde-sale-badge')) return;
    if (!PREVIEW && !hasRealDiscount(card)) return;
    var img = card.querySelector('img');
    if (!img) return;
    var host = img.closest('.card-gallery') || img.parentElement;
    if (!host) return;
    if (window.getComputedStyle(host).position === 'static') {
      host.style.position = 'relative';
    }
    var badge = document.createElement('div');
    badge.className = 'dadde-sale-badge';
    badge.textContent = discount + '% OFF';
    host.appendChild(badge);
  }

  function formatLikeOriginal(num, originalText) {
    var formatted = num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return originalText.replace(/[0-9][0-9.,]*/, formatted);
  }

  /* PREVIEW ONLY. Never runs for a real visitor, and never runs once Shopify
     is showing the genuine discounted price. */
  function addSimulatedPrices(card, discount) {
    if (!PREVIEW) return;
    if (hasRealDiscount(card)) return;
    var priceEls = card.querySelectorAll('.price');
    for (var i = 0; i < priceEls.length; i++) {
      var priceEl = priceEls[i];
      if (priceEl.getAttribute('data-dadde-sale')) continue;
      var text = (priceEl.textContent || '').trim();
      var match = text.match(/[0-9][0-9.,]*/);
      if (!match) continue;
      var original = parseFloat(match[0].replace(/,/g, ''));
      if (!(original > 0)) continue;
      var sale = original * (100 - discount) / 100;
      var strike = document.createElement('s');
      strike.className = 'dadde-compare-price';
      strike.textContent = text;
      priceEl.parentNode.insertBefore(strike, priceEl);
      priceEl.textContent = formatLikeOriginal(sale, text);
      priceEl.classList.add('dadde-sale-price');
      priceEl.setAttribute('data-dadde-sale', '1');
    }
  }

  function decorate() {
    buildBanner();
    addPreviewFlag();
    relabelSorting();
    var links = document.querySelectorAll('a[href*="/products/"]');
    for (var i = 0; i < links.length; i++) {
      var handle = handleFromHref(links[i].getAttribute('href') || '');
      if (!handle) continue;
      var discount = DISCOUNTS[handle];
      if (!discount) continue;
      var card = cardFor(links[i]);
      if (!card) continue;
      addBadge(card, discount);
      addSimulatedPrices(card, discount);
    }
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      decorate();
    });
  }

  function init() {
    if (!onSalePage()) return;
    injectStyles();
    decorate();
    if (window.MutationObserver && document.body) {
      new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    }
    document.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'sort_by') schedule();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
